import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TechAnalystScheduleService {

constructor(private httpClinet:HttpClient) { }

msAuth(){
    return this.httpClinet.get('UserCalendarConfigs/auth-url?type=microsoft');
}
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-analyst/shared/services/tech-analyst-schedule.service.ts